<template>
  <div class="flex flex-col">
    <input
      ref="inputRef"
      v-bind="$attrs"
      :name="name"
      type="text"
    >

    <span
      v-if="error"
      class="text-red-600 text-sm"
    >{{ error }}</span>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { CurrencyDisplay, CurrencyInputOptions, useCurrencyInput } from 'vue-currency-input';

defineOptions({
  inheritAttrs: false,
});

defineEmits<{
  (e: 'change');
}>();

const props = withDefaults(
  defineProps<{
    name: string;
    // modelValue: string | number | null | undefined;
    error?: string;
    options?: CurrencyInputOptions;
  }>(),
  {
    error: undefined,
    /* eslint-disable no-null/no-null */
    // modelValue: null,
    options: () => ({
      currency: 'AUD',
      currencyDisplay: CurrencyDisplay.narrowSymbol,
      hideGroupingSeparatorOnFocus: false,
    }),
  },
);

const inputValue = defineModel<number | undefined | string>();
const { inputRef, setOptions, setValue } = useCurrencyInput(props.options);

watch(inputValue, (newValue) => {
  setValue(newValue as number);
});

const focusInput = () => {
  inputRef.value?.focus();
};

const blur = () => {
  inputRef.value?.blur();
};

defineExpose({
  focusInput,
  blur,
  setOptions,
  setValue,
});
</script>

<style lang="css" scoped></style>
